import { issueRefundAtStatusValues } from '@/common/constants'

export const issueRefundAtStatusOptions = [
  {
    label: 'Gestionar manualmente',
    value: issueRefundAtStatusValues.manual,
  },
  {
    label: 'Cuando los productos hayan sido enviados por el cliente (Estado Enviado)',
    value: issueRefundAtStatusValues.shipped,
  },
  {
    label: 'Cuando los productos hayan sido recibidos en mi almacén (Estado Recibido)',
    value: issueRefundAtStatusValues.received,
  },
  {
    label: 'Al aceptar los productos devueltos (Estado Aceptado)',
    value: issueRefundAtStatusValues.accepted,
  },
]
